"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogLayout = void 0;
var icons_1 = require("@ant-design/icons");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var selectors_1 = require("../../redux/selectors");
var layout_1 = __importDefault(require("antd/es/layout"));
var menu_1 = __importDefault(require("antd/es/menu"));
var Content = layout_1.default.Content, Sider = layout_1.default.Sider;
var CarCatalogLayout = function () {
    var id = (0, react_router_dom_1.useParams)().id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var isLoading = (0, react_redux_1.useSelector)(selectors_1.catalogCarSelector).stateLoad.isLoading;
    var getSelectedKey = function () {
        var path = location.pathname;
        if (path.endsWith("/catalog/".concat(id)))
            return 'edit-catalog-main-info';
        if (path.includes('/color'))
            return 'edit-catalog-car_color';
        if (path.includes('/complectation'))
            return 'edit-catalog-complectation';
        if (path.includes('/texnos'))
            return 'edit-catalog-texnos';
        if (path.includes('/gallery'))
            return 'edit-catalog-images';
        return 'edit-catalog-main-info';
    };
    var menuItems = [
        {
            key: 'edit-catalog-main-info',
            icon: react_1.default.createElement(icons_1.CarOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/catalog/".concat(id) }, "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
        },
        {
            key: 'edit-catalog-car_color',
            icon: react_1.default.createElement(icons_1.PictureOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/catalog/".concat(id, "/color") }, "\u0426\u0432\u0435\u0442\u0430 \u043C\u0430\u0448\u0438\u043D\u044B"),
        },
        {
            key: 'edit-catalog-complectation',
            icon: react_1.default.createElement(icons_1.ToolOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/catalog/".concat(id, "/complectation") }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0438 \u0446\u0435\u043D\u044B"),
        },
        {
            key: 'edit-catalog-texnos',
            icon: react_1.default.createElement(icons_1.ToolOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/catalog/".concat(id, "/texnos") }, "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438"),
        },
        {
            key: 'edit-catalog-images',
            icon: react_1.default.createElement(icons_1.PictureOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/catalog/".concat(id, "/gallery") }, "\u0424\u043E\u0442\u043E\u0433\u0430\u043B\u0435\u0440\u0435\u044F"),
        },
    ];
    (0, react_1.useEffect)(function () {
        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
    }, [dispatch]);
    return (react_1.default.createElement(layout_1.default, { style: { minHeight: '100vh', backgroundColor: '#fff' } },
        react_1.default.createElement(Sider, { width: 300 },
            react_1.default.createElement(menu_1.default, { mode: "inline", selectedKeys: [getSelectedKey()], style: { height: '100%', borderRight: 0, paddingTop: '24px' }, items: menuItems })),
        react_1.default.createElement(layout_1.default, { style: { paddingLeft: '24px' } },
            react_1.default.createElement(Content, { style: {
                    padding: '24px',
                    margin: 0,
                    background: '#fff',
                    borderRadius: '8px',
                } }, isLoading ? react_1.default.createElement("div", { style: { marginTop: '50px', textAlign: 'center' } }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...") : react_1.default.createElement(react_router_dom_1.Outlet, null)))));
};
exports.CarCatalogLayout = CarCatalogLayout;
